<template>
  <div class="cycle-page">
    <page-head class="page-top" :noLogin="true"></page-head>
    <div class="left-data-content">
      <a href="javascript:;" class="qj-btn" @click="routerOk = true; loadRouter()" v-if="!routerOk">
        路径求解
      </a>
      <div class="content-div" v-else>
        <div class="text-one" v-for="item in tableData">{{item}}</div>
      </div>
    </div>
    <div class="content-map">
      <demo-map></demo-map>
    </div>
  </div>
</template>

<script>
import {
  axiosSysApi
} from '@/axios_init'
import DemoMap from '@/view/demo_map'
import PageHead from '../components/PageHead'
import SwitchMapBtn from '../components_bit/SwitchMapBtn'
export default {
  data () {
    return {
      // 坐标
      routerOk: false,
      lData: {},
      tableData: []
    }
  },
  components: {
    switch_map_btn: SwitchMapBtn,
    DemoMap,
    PageHead
  },
  created () {
    this.loadLocation()
  },
  methods: {
    loadLocation () {
      let dispatch = this.$store.dispatch
      dispatch('setLoading', true)
      dispatch('setLoadingText', '获取数据中')
      dispatch('setPercentage', {'start': 0, 'next': 100})
      axiosSysApi.get('/static/inputdemodata.json').then((response) => {
        let sData = []
        let eData = []
        let hData = []
        response.data.Coordinate.forEach((item) => {
          let location = item[1].split(',')
          location.forEach((itemL, index) => {
            location[index] = Number(itemL)
          })
          this.lData[item[0]] = location
          if (item[2] === 'center') {
            sData.push({name: item[0], value: location})
          } else if (item[2] === 'hos') {
            hData.push({name: item[0], value: location})
            console.log('wtf!!!!!!!!!!!!!')
          } else {
            eData.push({name: item[0], value: location})
          }
        })
        dispatch('setDemoMapDataPlant', sData)
        dispatch('setDemoMapDataCustomer', eData)
        dispatch('setDemoMapDataCenter', hData)
        dispatch('setLoadingText', '获取数据完成')
        dispatch('setPercentage', {'start': 100, 'next': 100})
      }).catch(function (e) {
        dispatch('showNoticeMsg', {
          type: 'error',
          title: '获取数据异常',
          message: '错误信息:' + e
        })
        dispatch('setLoadingText', '获取数据异常')
        dispatch('setPercentage', {'start': 100, 'next': 100})
        console.log(e)
      })
    },
    loadRouter () {
      let dispatch = this.$store.dispatch
      dispatch('setLoading', true)
      dispatch('setLoadingText', '求解路径中')
      dispatch('setPercentage', {'start': 0, 'next': 100})
      this.tableData = []
      axiosSysApi.get('/static/demooutput.json').then((response) => {
        let newData = []
        response.data.forEach((item) => {
          newData[item[2]] = item
        })
        let routers = [{name: '车辆1', data: []}]
        this.tableData = ['车辆1']
        newData.forEach((item) => {
          this.tableData.push(item[0])
          routers[0].data.push({
            fromName: item[0],
            toName: item[1],
            coords: [this.lData[item[0]], this.lData[item[1]]]
          })
        })
        dispatch('setDemoMapDataRoute', routers)
        dispatch('setLoadingText', '获取数据完成')
        dispatch('setPercentage', {'start': 100, 'next': 100})
      }).catch(function (e) {
        dispatch('showNoticeMsg', {
          type: 'error',
          title: '获取数据异常',
          message: '错误信息:' + e
        })
        dispatch('setLoadingText', '获取数据异常')
        dispatch('setPercentage', {'start': 100, 'next': 100})
        console.log(e)
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '../style/base.less';
.qj-btn {
  background-color: #081633;
  border-radius: 0.3rem;
  line-height: 2rem;
  margin-bottom: 3rem;
  color: #00ccff;
  width: 10rem;
  text-align: center;
  font-size: 0.9rem;
}
.content-div {
  border-top: 1px solid #081633;
  border-left: 1px solid #081633;
  border-right: 1px solid #081633;
}
.text-one {
  color: #00ccff;
  line-height: 2;
  padding: 0 1rem;
  border-bottom: 1px solid #081633;
}
.left-data-content {
 z-index: 1000;
 position: absolute;
 top: 6.13em;
 background-color: #012e53;
 bottom: 0;
 left: 0;
 width: 15rem;
 display: flex;
 flex-direction:column;
 align-items: center;
 justify-content: center;
}
.hide-map {
  z-index: -1;
}
.content-map {
  position: absolute;
  top: 6.13em;
  bottom: 0;
  left: 0;
  right: 0;
}
.page-top {
  z-index: 4;
}
.cycle-page {
  display: flex;
  flex:1;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// demo.vue?a7a728d8